import { useCallback } from 'react';
import { useRequestEmailChangeMutation } from 'shared/hooks/queries/use-request-email-change-mutation';

export const useRequestEmailChange = () => {
  const { mutate, reset, isPending, error, isSuccess, variables } =
    useRequestEmailChangeMutation();

  const requestEmailChange = useCallback(
    (newEmail: string, password: string) => mutate({ newEmail, password }),
    [mutate],
  );

  return {
    requestEmailChange,
    reset,
    isLoading: isPending,
    error: error?.kind,
    isSuccess,
    requestedEmail: variables?.newEmail,
  };
};
